import { http } from "../api/http";
import Utils from "../utils";

export const runbookService = {
  get,
  create,
  update,
  remove,
  reactivate,
  execute,
  getOverridableVariableLines,
  validate,
  cancel,
  preview,
  setTag,
};

async function get(requestParameters) {
  let url = `/runbook?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/runbook/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function update(requestBody) {
  let url = `/runbook/update`;

  return await http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function remove(requestParameters) {
  let url = `/runbook/delete?${Utils.objectToQueryString(requestParameters)}`;

  return await http.delete(url).then((response) => {
    return response;
  });
}

// #2646: drag-and-drop re-tag -- deliberately smaller than update(), touches only TagId.
async function setTag(requestBody) {
  let url = `/runbook/tag`;

  return await http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function reactivate(requestParameters) {
  // Reactivate binds its request [FromQuery] on the API, so params go in the query
  // string (like remove), not a JSON body.
  let url = `/runbook/reactivate?${Utils.objectToQueryString(requestParameters)}`;

  return await http.patch(url).then((response) => {
    return response;
  });
}

async function execute(requestBody) {
  let url = `/runbook/execute`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

// #2619: lines eligible to be overridden for a single run of this runbook -- fetched right
// before showing the "are you sure" confirm dialog, so it can offer them as editable inputs.
async function getOverridableVariableLines(requestParameters) {
  let url = `/runbook/overridablevariablelines?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function validate(requestBody) {
  let url = `/runbook/validate`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function cancel(requestBody) {
  const response = await http.post(`/runbook/cancel`, JSON.stringify(requestBody));
  return response;
}

async function preview(requestBody) {
  const response = await http.post(`/runbook/preview`, JSON.stringify(requestBody));
  return response;
}
